import React, { useState, useEffect, useRef } from 'react';
import { Tabs } from 'antd';
const { TabPane } = Tabs;
import Ads from './Ads';
import AdsPlansAdmin from './AdsPlansAdmin'
import AdminAdsToPharmacy from './AdminAdstoPhamacy';

export default function AdsPlansTab() {

    const onChange = (key) => {
        console.log(key);
      };

    return (
        <div>
            <Tabs  type="card">
                <TabPane tab="Ads" key="1">
                    <Ads />
                </TabPane>
                <TabPane tab="Ads Plans" key="2">
                   <AdsPlansAdmin />
                </TabPane>
                <TabPane tab="Admin Ads added to fharmcy" key="3">
                 <AdminAdsToPharmacy />
                </TabPane>
                
            </Tabs>
        </div>
    )

}